{
  "version": 1,
  "asset_id": "a7fd8c34-14b2-4a4e-bf4a-d5b22f131e2d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/a7fd8c34-14b2-4a4e-bf4a-d5b22f131e2d/lecanto-metal-roof-before-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/a7fd8c34-14b2-4a4e-bf4a-d5b22f131e2d/lecanto-metal-roof-before-1200w.webp",
  "original_filename": "lecanto-metal-roof-before-1200w.webp",
  "size": 301578,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
